/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ScanSignatureEntry } from '../../models/scan-signature-entry';
import { ScanSignatureResponse } from '../../models/scan-signature-response';

export interface ScanSignature$Params {
      body: ScanSignatureEntry
}

export function scanSignature(http: HttpClient, rootUrl: string, params: ScanSignature$Params, context?: HttpContext): Observable<StrictHttpResponse<ScanSignatureResponse>> {
  const rb = new RequestBuilder(rootUrl, scanSignature.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ScanSignatureResponse>;
    })
  );
}

scanSignature.PATH = '/api/v1/ScanSignature';
